'use strict';

/**
 * @Object
 * @description Handles PDP Sticky Elements
 */
var productStickyElements = {
    /**
    * @object
    * @description Cached vars
    */
    $cache: {
        stickyElement: $('.c-product-sticky-element'),
        stickyElementOffsetTop: ($('.c-product-sticky-element').length ? $('.c-product-sticky-element').offset().top : null),
        $productTopContent: $('.c-product__top-content'),
        $productImagesWrapper: $('.c-product__primary-image-container'),
        $productInfo: $('.c-product__info'),
        $productDetail: $('.product-detail'),
        flag: 0
    },

    /**
    * @function
    * @description Custom sticky function which is called on small screens
    */
    customStickyInit: function() {
        // for footer accordion to be fully scrollable and sticky part to overlap only with footer copyright
        $('.footer-container .copy').outerHeight(this.$cache.stickyElement.outerHeight());
        if ($(window).scrollTop() > this.$cache.stickyElementOffsetTop + $('.header').outerHeight()) {
            this.$cache.stickyElement.addClass('c-product__add-to-cart--sticky');
        } else {
            this.$cache.stickyElement.removeClass('c-product__add-to-cart--sticky');
        }
    },

    /**
    * @function
    * @description Plugin sticky function which is called on large screens
    */
    toggleDetailsSticky: function() {
        if (this.$cache.$productImagesWrapper.height() + this.$cache.$productInfo.height() > this.$cache.$productDetail.height()) {
            this.$cache.$productDetail.stick_in_parent({
                parent: '.c-product-details-wrapper',
                sticky_class: 'c-sticky-in-parent--stuck',
                offset_top: this.$cache.$productDetail.offset().top,
                spacer: false
            }).trigger('sticky_kit:recalc');
        } else {
            this.$cache.$productDetail.trigger('sticky_kit:detach');
        }
    },

    /**
    * @function
    * @description Handles the events in this component
    */
    initEvents: function() {
        var _that = this;

        import(/* webpackChunkName: "lodash" */ 'lodash').then((_) => {
            $(window).on('scroll resize load', _.debounce(function() {
                _that.customStickyInit();
            }, 10));
        });
    },

    init: function() {
        var _that = this;

        this.$cache.flag++;

        // current implementation did not account for the case when right column is higher that left
        // as this.$cache.$productTopContent is absolutely positioned and cannot increase container's height
        this.$cache.$productTopContent.css('min-height', this.$cache.$productDetail.height());
        $(document).on('pdp:details:content-update', () => {
            this.$cache.$productTopContent.css('min-height', this.$cache.$productDetail.height());
        });

        if (this.$cache.flag > 1) {
            this.$cache.stickyElement = $('.c-product-sticky-element');
            this.$cache.stickyElementOffsetTop = this.$cache.stickyElement.length ? this.$cache.stickyElement.offset().top : 0;
        }

        window.mqR.add(function (status) {
            if (status.phone || status.tablet) {
                $('.c-sticky-in-parent').trigger('sticky_kit:detach');
                _that.initEvents();
            }

            if (status.desktop || status.desktopLarge) {
                _that.toggleDetailsSticky();
            }
        });
    }
};

module.exports = productStickyElements;
